const DEMOTEMPLATE_SERVICE = '/api/demotemplate'

const createTemplate = async (app, country) => {
  const lastTemplate = await app
    .service(DEMOTEMPLATE_SERVICE)
    .find({
      query: {
        country: country,
        $sort: {
          version: -1
        },
        $limit: 1
      }
    })
    .catch(() => {
      throw new Error('Could not calculate new template version')
    })

  const startingVersion = 1
  const nextVersion =
    lastTemplate.total > 0 ? ++lastTemplate.data[0].version : startingVersion
  const isActive = lastTemplate.total === 0

  const query = {
    teamId: app.getTeamId(),
    country,
    isActive,
    version: nextVersion
  }

  return app.service(DEMOTEMPLATE_SERVICE).create(query, {})
}

const setActiveTemplate = async (app, version, country) => {
  // Check if target template exists
  const targetTemplate = await app.service(DEMOTEMPLATE_SERVICE).find({
    query: {
      country,
      version
    },
    $limit: 1
  })
  if (!targetTemplate.data || targetTemplate.data.length === 0) {
    throw new Error('Could not find template')
  }

  // Deactivate all active versions
  const currentActiveTemplates = await app.service(DEMOTEMPLATE_SERVICE).find({
    query: {
      country,
      isActive: true
    }
  })

  if (currentActiveTemplates.data && currentActiveTemplates.data.length > 0) {
    await Promise.all(
      currentActiveTemplates.data.map(template =>
        app
          .service(DEMOTEMPLATE_SERVICE)
          .patch(template.id, { isActive: false })
      )
    ).catch(() => {
      throw new Error('Could not deactivate current active template')
    })
  }

  // Activate target template
  const templateId = targetTemplate.data[0].id
  return app
    .service(DEMOTEMPLATE_SERVICE)
    .patch(templateId, { isActive: true })
    .catch(() => {
      throw new Error('Could not activate template')
    })
}

const getTemplates = (app, query, params) =>
  app.service(DEMOTEMPLATE_SERVICE).find({ ...params, query })

const getActiveTemplate = async (app, country, params) => {
  const query = {
    country,
    isActive: true
  }

  const activeTemplate = await getTemplates(app, query, params)
  if (!activeTemplate.data || activeTemplate.data.length !== 1) {
    throw new Error(`Could not find active template for country: ${country}`)
  }

  return activeTemplate.data[0]
}

const getTemplateList = async (app, country) => {
  const templates = await getTemplates(app, { country })
  return templates.data
}

module.exports = {
  createTemplate,
  setActiveTemplate,
  getActiveTemplate,
  getTemplateList
}
